import { AdminIntelligence } from '@/components/admin/AdminIntelligence';

export default function AdminIntelligencePage() {
  return (
    <div className="container mx-auto py-8 px-4 max-w-7xl">
      <AdminIntelligence />
    </div>
  );
}
